// extracted by mini-css-extract-plugin
export var measureBox = "_cp-0";